import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback } from 'react';
import { useUncontrolledProp } from 'uncontrollable';
import { SELECTION_MODE } from '../../constants';
import { ToggleGroupContext } from '../../context';
export function ToggleGroup({ children, value: valueProp, onChange: onChangeProp, selectionMode = SELECTION_MODE.Single, defaultValue, }) {
    const [value, setValue] = useUncontrolledProp(valueProp, defaultValue, cb => {
        onChangeProp === null || onChangeProp === void 0 ? void 0 : onChangeProp(cb(value));
    });
    const onChange = useCallback((newValue) => {
        if (selectionMode === SELECTION_MODE.Single) {
            return setValue((oldValue) => {
                if (newValue !== oldValue) {
                    return newValue;
                }
                return undefined;
            });
        }
        return setValue((oldValues = []) => {
            if (Array.isArray(oldValues)) {
                if (oldValues.includes(newValue)) {
                    return oldValues.filter(oldValue => oldValue !== newValue);
                }
                return oldValues.concat(newValue);
            }
            return undefined;
        });
    }, [selectionMode, setValue]);
    return (_jsx(ToggleGroupContext.Provider, { value: { value, onChange, selectionMode }, children: children }));
}
